const Shipping = () => {
  return (
    <>
      <h2>Shipping</h2>
    </>
  );
};

export default Shipping;
